import { PAYOUT_INTERVAL, PAYOUT_STATUSES } from '../../../../../../services/exports/Constants';

export default {
  headers: {
    payout_info: 'Uitbetalingsinfo',
    payouts: 'Uitbetalingen',
  },
  form: {
    invoicing_emails: {
      label: 'Facturen verzenden naar',
      placeholder: 'Voer uw e-mailadres in',
    },
    payout_schedule: {
      label: 'Uitbetalingsschema',
      options: {
        [PAYOUT_INTERVAL.MANUAL]: 'Uitbetalingen gepauzeerd',
        [PAYOUT_INTERVAL.DAILY]: 'Dagelijkse uitbetalingen',
        [PAYOUT_INTERVAL.WEEKLY]: 'Wekelijkse uitbetalingen',
        [PAYOUT_INTERVAL.MONTHLY]: 'Maandelijkse uitbetalingen',
      },
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    amount: 'Bedrag',
    cash_amount: 'Contant bedrag',
    paypal_standalone_amount: 'PayPal-bedrag',
    period: 'Periode',
    paid_at: 'Betaald op',
    provider: 'Aanbieder',
    status: 'Status',
    actions: 'Acties',
  },
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
    paypal: 'PayPal',
    paypal_standalone: 'PayPal',
    cash: 'Contant',
    system: 'Systeem',
  },
  buttons: {
    save: 'Opslaan',
    actions: 'Acties',
    open_report: 'Rapport openen',
    open_tracking_url: 'Uitbetaling volgen',
  },
  statuses: {
    [PAYOUT_STATUSES.created]: 'In behandeling',
    [PAYOUT_STATUSES.processing]: 'In verwerking',
    [PAYOUT_STATUSES.paid]: 'Betaald',
    [PAYOUT_STATUSES.failed]: 'Mislukt',
    undefined: 'Onbekend',
    null: 'Onbekend',
  },
  toasts: {
    failed_to_load_data: 'Gegevens ophalen mislukt',
    successfully_updated: 'Succesvol bijgewerkt',
  },
};
